module.exports = "./img/18fd831421965942e0cdae36b57c5261.jpg";